module.exports = __webpack_public_path__ + "img/xuanchuan1.956514e3.png";